import { render, staticRenderFns } from "./KnInterfaceColorTheme.vue?vue&type=template&id=760c6477"
import script from "./KnInterfaceColorTheme.js?vue&type=script&lang=js&external"
export * from "./KnInterfaceColorTheme.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports